
export const PERIODICIDAD_DECLARACION_JURADA = {

    MENSUAL: 390,
    BIMESTRAL: 391,
    TRIMESTRAL: 392,
    SEMESTRAL: 393,
    ANUAL: 394

}

export const PERIODICIDAD_ANUAL = PERIODICIDAD_DECLARACION_JURADA.ANUAL;
